import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { OrganizationCoworker } from "../organization.types";

type Args = {
  organizationId: number;
  enabled?: boolean;
};

/**
 * Fetch coworkers (active admins + pending invitations) for an organization.
 */
export function useFetchOrganizationCoworkers({
  organizationId,
  enabled = true,
}: Args) {
  return useQuery<OrganizationCoworker[]>({
    queryKey: ["organization", organizationId, "coworkers"],
    queryFn: async () => {
      return await apiRequest(
        `/organization/${organizationId}/coworkers/`,
        "GET"
      );
    },
    enabled: enabled && !!organizationId,
  });
}
